module.exports = __webpack_public_path__ + "static/media/book_animation.f72ee155.gif";